export default "__VITE_ASSET__BGLiY2Ku__"